import React from 'react'
import _ from 'lodash'
import { ROUTES } from '../../navigation/route-constants'
import LOCALE from '../MovieListLocale'
import CONSTANTS from '../movielist-constants'
import MovieInfo from '../../movie/MovieInfo'
import Poster from '../../movie/Poster'
import moment from 'moment'


export default class FutureMoviesListItem extends React.Component {
    constructor(props) {
        super(props);
        this.movieClicked = this.movieClicked.bind(this);
    }

    movieClicked(e) {
        const { movieClicked } = this.props;
        const dataset = e.target.dataset;
        if (e.target.tagName != 'A') e.preventDefault();

        const movieId = e.currentTarget.id || dataset.movieId;
        if (e.target.tagName == 'IMG' || e.target.tagName == 'H1' || e.target.tagName == 'INPUT' || _.includes(e.target.classList, 'poster-banner'))
            movieClicked(movieId);
    }

    render() {
        const { movie, rowClasses, appLocale, organizerIds, columns, hasShowtimes } = this.props;
        // console.log(movie)
        const info = movie.info && !_.isObject(movie.info) ? <p className="info" dangerouslySetInnerHTML={{ __html: movie.info.replace(/(?:\r\n|\r|\n)/g, '<br />') }} /> : null;

        const poster = movie.posters ?
            <a className="poster-container" href={`${window.location.origin}${ROUTES.MOVIEV2}/${movie.id}?org=${organizerIds}`}>
                <Poster movie={movie} /></a> : null;

        const movieNameLocale = movie.names ? (movie.names[appLocale] ? movie.names[appLocale] : movie.names['da']) : movie.name;
        const descriptionLocale = movie.descriptions ? (movie.descriptions[appLocale] ? movie.descriptions[appLocale] : movie.descriptions['da']) : movie.description;
        const description = descriptionLocale ? <p key={movie.id} className="description" dangerouslySetInnerHTML={{ __html: descriptionLocale.replace(/(?:\r\n|\r|\n)/g, ) }} /> : null;
        const isDefault = moment(movie.openingDate).isSame(moment('1600-01-01'), 'date');
        const premiere = movie.openingDate && !isDefault ? <p className="premiere"><span>Premiere:  </span><label>{moment(movie.openingDate).format('LL')}</label></p> : null;
        const genre = movie.genre ? <p className='genre'>{movie.genre}</p> : null;

        return (
            <div className={rowClasses} id={movie.id} onClick={this.movieClicked}>
                {poster}
                <div className="movie-info">
                    <a href={`${window.location.origin}${ROUTES.MOVIE}/${movie.id}?org=${organizerIds}`}><h1>{movieNameLocale}</h1></a>
                    {premiere}
                    {genre}
                    <div className="future-info">
                        {/*<MovieInfo movie={movie} showTitle={false} appLocale={appLocale} />*/}
                        {info}
                         {description}
                       
                        
                    </div>
                    <input type="button" className="next-btn" data-movie-id={movie.id}
                        value={hasShowtimes ? LOCALE[appLocale].buyTickets : (columns == CONSTANTS.columns.one ? LOCALE[appLocale].moreInfo : LOCALE[appLocale].readMore)} />

                </div>
            </div>
        )
    }
}